import { SURVEY_STATUS } from '@ps/survey-kernel';
import { SurveyFilters } from '../models';

export const INITIAL_SURVEY_FILTERS: Readonly<SurveyFilters> = {
  status: SURVEY_STATUS.LIVE,
  search: null,
  searchTitle: null,
  buyerId: null,
  countryCode: null,
  crmId: null,
  reconciliation: null,
  billing: null,
  operatorPm: null,
  buyerPm: null,
  template: null,
  tc: null,
  projectType: null,
  score: null,
  healthCheckAlert: null,
  healthCheckAlertLevel: null,
};
